var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconPoint = function SvgIconPoint(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 26 26"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.95,
    d: "M12.7 7.8c-2.154 0-3.9 1.164-3.9 2.6s1.746 2.6 3.9 2.6 3.9 1.164 3.9 2.6-1.746 2.6-3.9 2.6m0-10.4c1.443 0 2.704.523 3.379 1.3M12.7 7.8V6.5m0 1.3v10.4m0 0v1.3m0-1.3c-1.443 0-2.704-.522-3.379-1.3M24.4 13A11.7 11.7 0 1 1 1 13a11.7 11.7 0 0 1 23.4 0"
  })));
};
export default SvgIconPoint;